<template>
  <v-app>
    <base-modal />
    <div>
      <app-bar></app-bar>
    </div>
    <app-navigation-drawer></app-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
    <v-snackbar
      style="z-index: 9999"
      color="#D50000"
      :value="!!error"
      @input="error = null"
      max-width="500"
      multiple
      :timeout="10000"
    >
      <template v-slot>
        <div style="display: flex; align-items: center;">
          <div>
            {{ error }}
          </div>
          <v-btn class="ml-4" v-bind="$attrs" @click="error = null">
            Close
          </v-btn>
        </div>
      </template>
    </v-snackbar>
    <modals-container />
  </v-app>
</template>

<script>
import AppNavigationDrawer from './menu';
import AppBar from './app-bar/AppBar';
import { computed, provide } from '@vue/composition-api';
import useErrors from '@/api/errors';
import BaseModal from '@/components/BaseModal';
import useModal from '@/compositions/useModal';

export default {
  name: 'LayoutDefault',
  components: {
    BaseModal,
    AppNavigationDrawer,
    AppBar
  },
  setup() {
    const { error } = useErrors();
    provide('modalComposition', useModal());
    return {
      error
    };
  }
};
</script>
